import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { DefaultBenefitsList } from './DefaultBenefitsList.js';
import { TabularBenefitsList } from './TabularBenefitsList.js';
export const BenefitsList = JSX(({ isTabularBenefits, ...rest }) => isTabularBenefits ? _jsx(TabularBenefitsList, { ...rest }) : _jsx(DefaultBenefitsList, { ...rest }));
//# sourceMappingURL=BenefitsList.js.map